'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/exclamation/ExclamationIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ExclamationIcon = ({ className = "" }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "20",
      height: "21",
      viewBox: "0 0 20 21",
      fill: "none",
      className,
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("circle", { cx: "10", cy: "10.6659", r: "8.33333", stroke: "currentColor", strokeWidth: "1.5" }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: "9.16669",
            y: "8.99927",
            width: "1.66667",
            height: "5.83333",
            rx: "0.833333",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: "9.16669",
            y: "6.49927",
            width: "1.66667",
            height: "1.66667",
            rx: "0.833333",
            fill: "currentColor"
          }
        )
      ]
    }
  );
};

// src/exclamation/Triangle.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var ExclamationTriangleIcon = (props) => {
  return /* @__PURE__ */ jsx2(
    "svg",
    __spreadProps(__spreadValues({
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx2(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20 3.33301C20.5882 3.33301 21.1328 3.64303 21.4331 4.14878L37.2664 30.8154C37.5723 31.3306 37.5781 31.9702 37.2818 32.4908C36.9854 33.0115 36.4324 33.333 35.8333 33.333H4.16667C3.56759 33.333 3.0146 33.0115 2.71823 32.4908C2.42186 31.9702 2.42772 31.3306 2.73358 30.8154L18.5669 4.14878C18.8672 3.64303 19.4118 3.33301 20 3.33301ZM7.09456 29.9997H32.9054L20 8.2642L7.09456 29.9997ZM20 14.9997C20.9205 14.9997 21.6667 15.7459 21.6667 16.6663V19.9997C21.6667 20.9202 20.9205 21.6663 20 21.6663C19.0795 21.6663 18.3333 20.9202 18.3333 19.9997V16.6663C18.3333 15.7459 19.0795 14.9997 20 14.9997ZM17.9167 24.9997C17.9167 23.8491 18.8494 22.9163 20 22.9163C21.1506 22.9163 22.0833 23.8491 22.0833 24.9997C22.0833 26.1503 21.1506 27.083 20 27.083C18.8494 27.083 17.9167 26.1503 17.9167 24.9997Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  ExclamationIcon,
  ExclamationTriangleIcon
};
//# sourceMappingURL=chunk-RSYVDOOE.mjs.map